import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Navbar } from "../Navbar";
import { Footer } from "../Footer";
import { ScrollToTop } from "../ScrollToTop";
import { BackToTopButton } from "../BackToTopButton";
import { FloatingWhatsApp } from "../FloatingWhatsApp";
import { PageTransition } from "../PageTransition";

const MainLayout = () => {
  const location = useLocation();

  return (
    <div className="relative min-h-screen overflow-x-hidden">
      <div
        className="pointer-events-none fixed inset-0 -z-10 site-atmosphere"
        aria-hidden="true"
      />
      <ScrollToTop />
      <Navbar />
      <main className="relative pt-20 sm:pt-24 px-2 sm:px-4 lg:px-6 pb-4 sm:pb-6">
        <div className="layout-frame">
          <AnimatePresence mode="wait">
            <PageTransition key={location.pathname}>
              <Outlet />
            </PageTransition>
          </AnimatePresence>
        </div>
      </main>
      <Footer />
      <BackToTopButton />
      <FloatingWhatsApp />
    </div>
  );
};

export default MainLayout;
